import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "configs/MsalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);